import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { DeviceType } from "../../../types/enums";

type DownloadLinkWithTextProps = {
  linkText: ReactNode;
  href: string;
};

export const DownloadLinkWithText: FC<DownloadLinkWithTextProps> = ({
  linkText,
  href,
}) => {
  return (
    <a download href={href} target={"_blank"} rel="noreferrer">
      {linkText}
    </a>
  );
};

type DownloadSizeGuideProps = {
  deviceTypes: DeviceType[];
};

export const DownloadSizeGuide = ({ deviceTypes }: DownloadSizeGuideProps) => {
  const { t } = useTranslation();
  let href = "";
  if (deviceTypes.includes(DeviceType.Elbow)) {
    href = "https://precure-cdn.azureedge.net/images/elbow_size_guide.png";
  }
  if (deviceTypes.includes(DeviceType.Back)) {
    href = "https://precure-cdn.azureedge.net/images/temp_back_size_guide.png";
  }

  return (
    <DownloadLinkWithText linkText={t("labels.sizeGuideLink")} href={href} />
  );
};
